import {
    IClientMessageUseCase,
    IClientMessage,
    ISelectedData,
    IReadQuery,
    IClientMessageCreateDto,
    IClientMessageUpdateDto,
} from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";
import { QueryConverter } from "@/utils/plugins/query-converter";

export class ClientMessageUseCase implements IClientMessageUseCase {
    public async select(
        companyId: string,
        clientId: string,
        query?: IReadQuery,
    ): Promise<ISelectedData<IClientMessage>> {
        try {
            const params = QueryConverter.objectToQuery(query);
            const response = await Api.get<ISelectedData<IClientMessage>>(
                `/companies/${companyId}/clients/${clientId}/messages`,
                {
                    params,
                },
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async get(companyId: string, clientId: string, messageId: string): Promise<IClientMessage> {
        try {
            const response = await Api.get<IClientMessage>(
                `/companies/${companyId}/clients/${clientId}/messages/${messageId}`,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    // public async create(companyId: string, clientId: string, dto: IClientMessageCreateDto): Promise<IClientMessage> {
    //     try {
    //         const response = await Api.post<IClientMessage>(
    //             `/companies/${companyId}/clients/${clientId}/messages`,
    //             dto,
    //         );
    //         return response.data;
    //     } catch (e: any) {
    //         throw new DataLoadException(e);
    //     }
    // }

    // public async update(
    //     companyId: string,
    //     clientId: string,
    //     messageId: string,
    //     dto: IClientMessageUpdateDto,
    // ): Promise<IClientMessage> {
    //     try {
    //         const response = await Api.put<IClientMessage>(
    //             `/companies/${companyId}/clients/${clientId}/messages/${messageId}`,
    //             dto,
    //         );
    //         return response.data;
    //     } catch (e: any) {
    //         throw new DataLoadException(e);
    //     }
    // }

    public async delete(companyId: string, clientId: string, messageId: string): Promise<void> {
        try {
            await Api.delete<void>(`/companies/${companyId}/clients/${clientId}/messages/${messageId}`);
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
